/**
 * Loads the curated cross-sell rows for the product page.
 *
 * Shopify only fills the `recommendations` object on a render that comes from
 * the recommendations endpoint, so the block ships empty and fetches itself -
 * the same trick as the theme's <product-recommendations>.
 *
 * It does NOT reuse that element. Both this block and the theme's native
 * complementary block live inside the main-product section, so both fetches
 * return the same rendered section; the theme's element picks its content with
 * querySelector('product-recommendations'), which would hand the first match's
 * markup to every instance. A separate tag name keeps the two apart.
 */
if (!customElements.get('knuska-cross-sell')) {
  class KnuskaCrossSell extends HTMLElement {
    /*
     * Fetched on connect, NOT through the theme's initLazyScript.
     *
     * That helper waits on an IntersectionObserver, and this element is hidden
     * by CSS until it has rows to show - a display:none element never
     * intersects, so the observer would never fire, the fetch would never run,
     * and the block would stay empty and hidden forever. It also sits in the
     * buy column, above the fold, so there is nothing to defer.
     */
    connectedCallback() {
      if (this.loaded) return;
      this.loaded = true;
      this.init();
    }

    async init() {
      const { url, productId } = this.dataset;
      if (!url || !productId) return;

      try {
        const response = await fetch(url);
        if (!response.ok) throw new Error(response.status);

        const tmpl = document.createElement('template');
        tmpl.innerHTML = await response.text();

        const el = tmpl.content.querySelector('knuska-cross-sell');
        if (el && el.hasChildNodes()) {
          this.innerHTML = el.innerHTML;
        }
      } catch (error) {
        console.log(error); // eslint-disable-line
      }
    }
  }

  customElements.define('knuska-cross-sell', KnuskaCrossSell);
}
